import React from 'react';
import styled from 'styled-components';
import { Box } from '~common/components/box.component';
import { Title } from '~common/components/title.component';

export const RouterTest: React.FunctionComponent = () => {
  return (
    <Container>
      <Title>Test Router is working!</Title>
    </Container>
  );
};

const Container = styled(Box)`
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background: ${(props): string => props.theme.colors.black};
`;



// WEBPACK FOOTER //
// ./view/components/__tests__/components/router.test.component.tsx